/* Mobile product media modal: native scroll-snap sliding,
   thumbnail sync, add-to-cart proxy, video autoplay in modal + gallery. Mobile-only. */
(function () {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  // ── Toast ────────────────────────────────────────────────────────────────

  var toastTimer = null;

  function getOrCreateToast() {
    var el = document.getElementById('ct-atc-toast');
    if (el) return el;

    el = document.createElement('div');
    el.id = 'ct-atc-toast';
    el.innerHTML =
      '<div class="ct-atc-toast__inner">' +
        '<div class="ct-atc-toast__image-wrap">' +
          '<img id="ct-atc-toast-img" src="" alt="" loading="lazy">' +
        '</div>' +
        '<div class="ct-atc-toast__text">' +
          '<span class="ct-atc-toast__title">View Cart</span>' +
          '<span class="ct-atc-toast__count" id="ct-atc-toast-count"></span>' +
        '</div>' +
        '<div class="ct-atc-toast__arrow">&#8250;</div>' +
      '</div>';

    el.addEventListener('click', function () {
      el.classList.remove('ct-atc-toast--active');
      clearTimeout(toastTimer);
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) cartDrawer.open();
    });

    document.body.appendChild(el);
    return el;
  }

  function showToast(imageUrl, itemCount) {
    var toast = getOrCreateToast();
    var img = document.getElementById('ct-atc-toast-img');
    var count = document.getElementById('ct-atc-toast-count');

    if (img) img.src = imageUrl || '';
    if (count) count.textContent = itemCount + ' Item' + (itemCount !== 1 ? 's' : '');

    clearTimeout(toastTimer);
    toast.classList.add('ct-atc-toast--active');

    toastTimer = setTimeout(function () {
      toast.classList.remove('ct-atc-toast--active');
    }, 5000);
  }

  // ── Cart section update ──────────────────────────────────────────────────
  // Updates cart-icon-bubble which triggers ct-atc-flow.js's MutationObserver
  // → syncAllQtySelectors → transforms the PDP's ATC button to qty selector.

  function updateCartIconBubble(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    var el = document.getElementById('cart-icon-bubble');
    if (!el) return;
    var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    var source = doc.querySelector('.shopify-section');
    var dest = el.querySelector('.shopify-section') || el;
    if (source) dest.innerHTML = source.innerHTML;
  }

  // ── Modal qty selector ───────────────────────────────────────────────────
  // Separate from ct-atc-flow.js's .ct-qty-selector — lives inside the modal
  // footer which has no product-form ancestor, so ct-atc-flow.js ignores it.

  function transformModalToQty(footer, variantId, qty, key) {
    var existing = footer.querySelector('.product-media-modal__qty');
    if (existing) {
      var countEl = existing.querySelector('.ct-qty-selector__count');
      if (countEl) countEl.textContent = qty;
      if (key) existing.dataset.key = key;
      return;
    }

    var atcBtn = footer.querySelector('.product-media-modal__atc');
    var computedBg = null, computedBorder = null, computedRadius = null;
    if (atcBtn) {
      var s = window.getComputedStyle(atcBtn);
      computedBg = s.backgroundColor;
      computedBorder = s.border;
      computedRadius = s.borderRadius;
      atcBtn.style.display = 'none';
    }

    var selector = document.createElement('div');
    selector.className = 'product-media-modal__qty ct-qty-selector';
    selector.dataset.variantId = String(variantId);
    if (key) selector.dataset.key = key;

    if (computedBg) selector.style.backgroundColor = computedBg;
    if (computedBorder) selector.style.border = computedBorder;
    if (computedRadius) selector.style.borderRadius = computedRadius;

    selector.innerHTML =
      '<button class="ct-qty-selector__btn ct-qty-btn-minus" type="button">&#8722;</button>' +
      '<span class="ct-qty-selector__count">' + qty + '</span>' +
      '<button class="ct-qty-selector__btn ct-qty-btn-plus" type="button">+</button>';

    footer.appendChild(selector);
  }

  function revertModalToAtc(footer) {
    var selector = footer.querySelector('.product-media-modal__qty');
    if (selector) selector.remove();
    var atcBtn = footer.querySelector('.product-media-modal__atc');
    if (atcBtn) {
      atcBtn.style.display = '';
      atcBtn.disabled = false;
    }
  }

  function syncModalFooterWithCart(footer, variantId) {
    // Read synchronously from the PDP's qty selector — ct-atc-flow.js already
    // built this on page load so no network request is needed, no flash.
    var pdpSelector = document.querySelector('product-form .ct-qty-selector[data-variant-id="' + variantId + '"]');
    if (pdpSelector) {
      var countEl = pdpSelector.querySelector('.ct-qty-selector__count');
      var qty = countEl ? (parseInt(countEl.textContent, 10) || 1) : 1;
      var key = pdpSelector.dataset.key || String(variantId);
      transformModalToQty(footer, variantId, qty, key);
      return;
    }

    // No PDP qty selector means the PDP is showing ATC (item removed from cart).
    // Revert immediately so the modal doesn't show stale - qty + state.
    revertModalToAtc(footer);

    // Safety-net fetch: in the rare case the PDP selector wasn't rendered yet
    // but the cart still has the item, restore the qty selector.
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cartItem = cart.items.find(function (item) {
          return String(item.variant_id) === String(variantId);
        });
        if (cartItem) {
          transformModalToQty(footer, variantId, cartItem.quantity, cartItem.key);
        }
      })
      .catch(function () {});
  }

  function getVariantIdFromModal(atcButton) {
    var submitButton = document.getElementById(atcButton.getAttribute('data-submit-id'));
    var productForm = submitButton && submitButton.closest('product-form');
    var variantInput = productForm && productForm.querySelector('input[name="id"]');
    return variantInput ? variantInput.value : null;
  }

  // ── Media helpers ────────────────────────────────────────────────────────

  function getItems(modal) {
    return Array.from(
      modal.querySelectorAll('.product-media-modal__content > [data-media-id]')
    );
  }

  function setActiveThumb(modal, mediaId) {
    modal.querySelectorAll('[data-modal-thumb]').forEach((thumb) => {
      const isActive = thumb.getAttribute('data-modal-thumb') === mediaId;
      thumb.classList.toggle('is-active', isActive);
      if (isActive) {
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    });
  }

  function scrollToIndex(content, idx, smooth) {
    content.scrollTo({
      left: idx * content.clientWidth,
      behavior: smooth ? 'smooth' : 'instant'
    });
  }

  function playDeferredVideo(deferredMedia) {
    if (!deferredMedia) return;

    const posterIcon = deferredMedia.querySelector('.deferred-media__poster-button');
    if (posterIcon) posterIcon.style.display = 'none';

    if (!deferredMedia.hasAttribute('loaded')) {
      if (typeof deferredMedia.loadContent === 'function') {
        deferredMedia.loadContent(false);
      } else {
        const posterBtn = deferredMedia.querySelector('.deferred-media__poster');
        if (posterBtn) posterBtn.click();
      }
    }

    requestAnimationFrame(() => {
      const video = deferredMedia.querySelector('video');
      if (video) {
        video.removeAttribute('controls');
        video.loop = true;
        video.muted = true;
        video.currentTime = 0;
        video.play().catch(() => {});
      }
      const poster = deferredMedia.querySelector('.deferred-media__poster');
      if (poster) poster.style.display = 'none';
    });
  }

  function pauseDeferredVideo(el) {
    if (!el) return;
    const video = el.querySelector('video');
    if (video && !video.paused) video.pause();
  }

  // ── Modal: scroll-snap + thumbnail + ATC ──────────────────────────────────

  function initModal(modal) {
    if (!mobileQuery.matches) return;

    const footer = modal.querySelector('.product-media-modal__footer');
    if (!footer) return;

    // Re-run on gallery:updated only binds nodes that were actually replaced.
    if (modal.dataset.modalMobileInit) return;
    modal.dataset.modalMobileInit = 'true';

    const content = modal.querySelector('.product-media-modal__content');
    const items = getItems(modal);
    let currentIdx = -1;
    // Target slide of a click-initiated smooth scroll. While set, the scroll
    // listener must not re-derive the active thumb from the live scroll position
    // — otherwise the border flickers back to the source slide mid-animation.
    let programmaticTargetIdx = -1;
    // Timestamp of last modal-initiated qty change — prevents the cart sync
    // MutationObserver from overwriting the modal's state with stale PDP data
    // before ct-atc-flow.js's async syncAllQtySelectors() finishes its fetch.
    var lastModalQtyChange = 0;

    // ── Gift sync (shared with ct-atc-flow.js) ────────────────────────────
    // The modal's ATC / qty handlers mutate the cart directly, so they must run
    // the same free-gift logic as the other cart paths. ct-atc-flow.js exposes
    // it on window. The cart drawer's loader is hidden behind the modal, so we
    // show a modal-scoped overlay (same look) while the gift is added/removed.

    function showGiftLoader() {
      var loader = modal.querySelector('.product-media-modal__loader');
      if (!loader) {
        loader = document.createElement('div');
        loader.className = 'product-media-modal__loader';
        loader.innerHTML = '<span class="loader"></span>';
        modal.appendChild(loader);
      }
      loader.style.display = 'flex';
    }

    function hideGiftLoader() {
      var loader = modal.querySelector('.product-media-modal__loader');
      if (loader) loader.style.display = 'none';
    }

    function syncGiftForModal(cartState) {
      if (typeof window.ctSyncGift !== 'function') return;
      var willChange = typeof window.ctGiftWillChange === 'function' && window.ctGiftWillChange(cartState);
      if (willChange) showGiftLoader();
      window.ctSyncGift(cartState)
        .then(function () { if (willChange) hideGiftLoader(); })
        .catch(function () { if (willChange) hideGiftLoader(); });
    }

    function onActiveChange(idx) {
      if (idx === currentIdx) return;
      pauseDeferredVideo(items[currentIdx]);
      currentIdx = idx;
      const item = items[idx];
      if (!item) return;
      setActiveThumb(modal, item.getAttribute('data-media-id'));
      if (item.tagName === 'DEFERRED-MEDIA') playDeferredVideo(item);
    }

    footer.querySelectorAll('[data-modal-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const mediaId = thumb.getAttribute('data-modal-thumb');
        const idx = items.findIndex((item) => item.getAttribute('data-media-id') === mediaId);
        const currentScrollIdx = Math.round(content.scrollLeft / content.clientWidth);
        // Only guard when the scroll actually moves — tapping the already-active
        // thumb fires no scroll event, which would otherwise leave the guard set.
        if (idx !== -1 && idx !== currentScrollIdx) {
          programmaticTargetIdx = idx;
          scrollToIndex(content, idx, true);
        }
        setActiveThumb(modal, mediaId);
      });
    });

    // ── ATC button: direct cart fetch, no modal close, no drawer ──────────

    const atcButton = footer.querySelector('.product-media-modal__atc');
    if (atcButton) {
      atcButton.addEventListener('click', function () {
        var variantId = getVariantIdFromModal(atcButton);
        if (!variantId) return;

        // Guard the sync observer immediately — it fires 200ms after we update
        // the cart bubble, and at that point ct-atc-flow.js may not have finished
        // its own /cart.js fetch. Without this guard the observer would read stale
        // data from the PDP and revert the modal back to ATC.
        lastModalQtyChange = Date.now();

        // Immediately hide ATC and show qty=1 in loading state — mirrors
        // ct-atc-flow.js's synchronous transformToQty(), prevents the
        // black-border flash, and blocks +/- while the fetch is in flight.
        transformModalToQty(footer, variantId, 1, String(variantId));
        var atcSelector = footer.querySelector('.product-media-modal__qty');
        if (atcSelector) {
          atcSelector.classList.add('ct-qty-selector--loading');
          atcSelector.querySelectorAll('.ct-qty-selector__btn').forEach(function (b) { b.disabled = true; });
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1, sections: ['cart-icon-bubble'] })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.status) {
              // Cart add failed — revert to ATC button
              lastModalQtyChange = 0;
              revertModalToAtc(footer);
              return;
            }

            // Refresh guard right before mutating the bubble so the 500ms window
            // starts from the mutation, not the click (which may have been >300ms ago).
            lastModalQtyChange = Date.now();
            updateCartIconBubble(data.sections);

            // Fetch full cart to resolve the real key and qty for the selector
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                var cartItem = cart.items.find(function (i) {
                  return String(i.variant_id) === String(variantId);
                });
                transformModalToQty(
                  footer,
                  variantId,
                  cartItem ? cartItem.quantity : 1,
                  cartItem ? cartItem.key : String(variantId)
                );
                lastModalQtyChange = Date.now();
                var sel = footer.querySelector('.product-media-modal__qty');
                if (sel) {
                  sel.classList.remove('ct-qty-selector--loading');
                  sel.querySelectorAll('.ct-qty-selector__btn').forEach(function (b) { b.disabled = false; });
                }
                // Add the free gift if this add crossed the ₹1199 threshold.
                syncGiftForModal(cart);
              })
              .catch(function () {
                var sel = footer.querySelector('.product-media-modal__qty');
                if (sel) {
                  sel.classList.remove('ct-qty-selector--loading');
                  sel.querySelectorAll('.ct-qty-selector__btn').forEach(function (b) { b.disabled = false; });
                }
                lastModalQtyChange = 0;
              });
          })
          .catch(function () {
            lastModalQtyChange = 0;
            revertModalToAtc(footer);
          });
      });
    }

    // ── Modal qty +/- ─────────────────────────────────────────────────────
    // ct-atc-flow.js's delegated handler skips these because they have no
    // product-form ancestor — we handle them here instead.

    footer.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.product-media-modal__qty .ct-qty-selector__btn');
      if (!btn) return;

      var selector = footer.querySelector('.product-media-modal__qty');
      if (!selector) return;

      var key = selector.dataset.key || selector.dataset.variantId;
      var variantId = selector.dataset.variantId;
      var countEl = selector.querySelector('.ct-qty-selector__count');
      var currentQty = parseInt(countEl ? countEl.textContent : '1', 10);
      var isMinus = btn.classList.contains('ct-qty-btn-minus');
      var newQty = isMinus ? currentQty - 1 : currentQty + 1;

      // Block the cart sync observer from overwriting the modal during this operation.
      lastModalQtyChange = Date.now();

      selector.classList.add('ct-qty-selector--loading');
      selector.querySelectorAll('.ct-qty-selector__btn').forEach(function (b) { b.disabled = true; });

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty, sections: ['cart-icon-bubble'] })
      })
        .then(function (r) { return r.json(); })
        .then(function (parsedState) {
          // Refresh guard before mutating the bubble so the 500ms window
          // starts from the mutation, not the click.
          lastModalQtyChange = Date.now();
          updateCartIconBubble(parsedState.sections);
          selector.classList.remove('ct-qty-selector--loading');

          if (newQty <= 0) {
            revertModalToAtc(footer);
          } else {
            if (countEl) countEl.textContent = newQty;
            selector.querySelectorAll('.ct-qty-selector__btn').forEach(function (b) { b.disabled = false; });
          }
          // Add/remove the free gift if this change crossed the ₹1199 threshold.
          syncGiftForModal(parsedState);
        })
        .catch(function () {
          selector.classList.remove('ct-qty-selector--loading');
          selector.querySelectorAll('.ct-qty-selector__btn').forEach(function (b) { b.disabled = false; });
          lastModalQtyChange = 0;
        });
    });

    // ── Scroll sync ───────────────────────────────────────────────────────

    let scrollTimer;
    content.addEventListener(
      'scroll',
      () => {
        // Update active class immediately on every frame so fast swipes
        // show the correct thumbnail highlight without any lag.
        const idx = Math.round(content.scrollLeft / content.clientWidth);

        // While a click-initiated smooth scroll is animating, the thumb click
        // already set the target border. Don't re-derive it from the live
        // scroll position — that would blink the border back to the source
        // slide until the animation crosses the halfway point. Clear the guard
        // once we've actually landed on the target.
        if (programmaticTargetIdx !== -1) {
          if (idx === programmaticTargetIdx) programmaticTargetIdx = -1;
        } else {
          const item = items[idx];
          if (item) {
            modal.querySelectorAll('[data-modal-thumb]').forEach((thumb) => {
              thumb.classList.toggle(
                'is-active',
                thumb.getAttribute('data-modal-thumb') === item.getAttribute('data-media-id')
              );
            });
          }
        }

        // Debounced for heavier work: video autoplay, scrollIntoView on thumb strip.
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          // Scrolling has settled — safety-clear the programmatic guard in case
          // the animation never reported an exact-target frame.
          programmaticTargetIdx = -1;
          onActiveChange(idx);
        }, 50);
      },
      { passive: true }
    );

    // ── Modal open/close observer ─────────────────────────────────────────

    new MutationObserver(() => {
      if (!modal.hasAttribute('open')) {
        pauseDeferredVideo(items[currentIdx]);
        currentIdx = -1;
        return;
      }
      requestAnimationFrame(() => {
        // Scroll to active slide
        const activeItem = content.querySelector('.active');
        if (activeItem) {
          const idx = items.indexOf(activeItem);
          if (idx !== -1) {
            scrollToIndex(content, idx, false);
            onActiveChange(idx);
          }
        }

        // Sync ATC / qty selector with current cart state
        if (atcButton) {
          var variantId = getVariantIdFromModal(atcButton);
          if (variantId) syncModalFooterWithCart(footer, variantId);
        }
      });
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });

    // ── Real-time cart sync ───────────────────────────────────────────────
    // cart-icon-bubble is updated by every cart mutation path (ATC, drawer +/-,
    // modal +/-, etc.) so observing it keeps the modal footer in sync whenever
    // it is open. Fire at 200ms — after ct-atc-flow.js's 150ms debounce —
    // so the PDP qty selector is already in its final state when we read it.

    if (atcButton) {
      var cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        var cartSyncTimer = null;
        new MutationObserver(function () {
          if (!modal.hasAttribute('open')) return;
          clearTimeout(cartSyncTimer);
          cartSyncTimer = setTimeout(function () {
            // Skip if the modal itself just changed qty — ct-atc-flow.js's
            // syncAllQtySelectors() may not have finished its /cart.js fetch
            // yet, so reading the PDP selector now would return stale data
            // and overwrite the modal's already-correct state.
            if (Date.now() - lastModalQtyChange < 500) return;
            var vid = getVariantIdFromModal(atcButton);
            if (vid) syncModalFooterWithCart(footer, vid);
          }, 200);
        }).observe(cartIconBubble, { childList: true, subtree: true, characterData: true });
      }
    }
  }

  // ── Gallery: autoplay video when slide is centred (IntersectionObserver) ──

  function initGalleryVideoAutoplay() {
    if (!mobileQuery.matches) return;

    document.querySelectorAll('.product__media-list').forEach((slider) => {
      // Re-run on gallery:updated only binds sliders that were actually replaced.
      if (slider.dataset.galleryAutoplayInit) return;
      slider.dataset.galleryAutoplayInit = 'true';

      let centeredSlide = null;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const slide = entry.target;

            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              centeredSlide = slide;
              const deferredMedia = slide.querySelector('deferred-media');
              if (deferredMedia) playDeferredVideo(deferredMedia);
            } else {
              if (centeredSlide === slide) centeredSlide = null;
              pauseDeferredVideo(slide);
            }
          });
        },
        { root: slider, threshold: [0, 0.6] }
      );

      slider.querySelectorAll('.product__media-item').forEach((slide) => observer.observe(slide));

      document.body.addEventListener('modalClosed', () => {
        if (!centeredSlide) return;
        const deferredMedia = centeredSlide.querySelector('deferred-media');
        if (deferredMedia) playDeferredVideo(deferredMedia);
      });
    });
  }

  document.querySelectorAll('product-modal').forEach(initModal);
  initGalleryVideoAutoplay();

  // A variant change replaces the gallery and modal nodes, so re-bind to the
  // fresh slides and modal.
  document.addEventListener('gallery:updated', function () {
    document.querySelectorAll('product-modal').forEach(initModal);
    initGalleryVideoAutoplay();
  });
})();
